import React from "react";
import * as Scrivito from "scrivito";
import { TableFooter } from "components/TableFooter";
import { ProjectListTableBody } from "./ProjectListTableBody";
import { useProjectListContext } from "../../hooks/useProjectListContext";

export const ProjectListTable = Scrivito.connect(() => {
  const {
    currentPageNo,
    setProjectsToDelete,
    filteredCount,
    pagesCount,
    itemsPerPage,
    handleSetCurrentPage,
    isSelectAll,
    setIsSelectAll,
  } = useProjectListContext();

  return (
    <div className="px-4 pt-2_5 pb-4 bg-white">
      <ProjectListTableBody
        isSelectAll={isSelectAll}
        setIsSelectAll={setIsSelectAll}
        setProjectsToDelete={setProjectsToDelete}
      />
      <TableFooter
        filteredCount={filteredCount}
        pagesCount={pagesCount}
        currentPageNo={currentPageNo}
        itemsPerPage={itemsPerPage}
        handleSetCurrentPage={handleSetCurrentPage}
      />
    </div>
  );
});
